//service/EmpresaService.js
import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class EmpresaService {

    async listAllEmpresas(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('agenda');
        const idEmpresa = RoleService.getEmpresa()

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllEmpresa(iss);
            case 'COMPANY':
                return this.getEmpresa(iss, idEmpresa);
            case 'SELF':
                return this.getEmpresa(iss, idEmpresa);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllEmpresa(data) {
        return axiosInstance.get(`${config.api.version}/empresa/${data}/get?ativo=0`)
    }

    getEmpresa(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/empresa/${data}/get/${id}`, {
            params: params
        })
    }

    getCompanySettings(data, companyId) {
        return axiosInstance.get(`${config.api.version}/empresa/${data}/${companyId}/settings`)
    }

    putCompanySettings(data, companyId, settings) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/${companyId}/settings`, settings)
    }

    getEmpresaPorCnpj(data, cnpj) {
        return axiosInstance.get(`${config.api.version}/empresa/${data}/get?document=${cnpj}`)
    }

    getMccByCnae(data, cnae) {
        return axiosInstance.get(`${config.api.version}/cnae-mcc/${data}/cnae/exists/${cnae}`)
    }

    postEmpresa(data, empresa) {
        return axiosInstance.post(`${config.api.version}/empresa/${data}/`, empresa, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    putEmpresa(data, empresa, id) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/${id}`, empresa, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    deleteEmpresa(data, id) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/delete/${id}`)
    }

    activeEmpresa(data, id, status) {
        return axiosInstance.put(`${config.api.version}/empresa/${data}/active/${id}/${status}`)
    }

    listAllBanks() {
        return axiosInstance.get(`https://brasilapi.com.br/api/banks/v1`)
    }
}
